import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";

export const RegistryPagination = ({
  cur,
  max,
  onClickNext,
  onClickPrev,
}: {
  cur: number;
  max: number;
  onClickNext: any;
  onClickPrev: any;
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        p: "12px 24px",
      }}
    >
      <Typography>
        Страница {cur} из {max}
      </Typography>
      <Box>
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
          }}
          disabled={cur == 1}
          variant={"outlined"}
          onClick={onClickPrev}
        >
          Назад
        </Button>
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            ml: "12px",
          }}
          disabled={cur == max}
          variant={"outlined"}
          onClick={onClickNext}
        >
          Вперед
        </Button>
      </Box>
    </Box>
  );
};
